import { useEffect, useState } from "react";
import { useSpinTheWheel, useTheme } from "../../../../hooks";
import { useHistory, useLocation } from "react-router-dom";
import { io } from "socket.io-client";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const initialColor = [
  { bgColor: "#F3F3E9", textColor: "black" },
  { bgColor: "#2FAF74", textColor: "white" },
  { bgColor: "#E65051", textColor: "white" },
  { bgColor: "#FBA629", textColor: "black" },
  { bgColor: "#2FAF74", textColor: "white" },
  { bgColor: "#39A1E8", textColor: "white" },
  { bgColor: "#CA3D77", textColor: "white" },

  { bgColor: "#F3F3E9", textColor: "black" },
  { bgColor: "#2FAF74", textColor: "white" },
  { bgColor: "#E65051", textColor: "white" },
  { bgColor: "#FBA629", textColor: "black" },
  { bgColor: "#2FAF74", textColor: "white" },
  { bgColor: "#39A1E8", textColor: "white" },
  { bgColor: "#CA3D77", textColor: "white" },
  { bgColor: "red", textColor: "white" },
];

const stockData = [{
  "code": "data_2.6",
  "name": "2.6GB Data bundle",
  "imageUrl": `${SERVER_URL}/assets/images/data_lady.png`,
  "category": "data"
},
{
  "code": "kfc",
  "name": "KFC Vouchers",
  "imageUrl": `${SERVER_URL}/assets/images/kfcmw.jpg`,
  "category": "voucher"
},
{
  "code": "hooded_shirt",
  "name": "Hooded T-Shirt",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/hooded-shirt.jpg`,
  "category": "souvenir"
},
{
  "code": "tank_top",
  "name": "Tank Tops",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/tanktop.jpg`,
  "category": "souvenir"
},
{
  "code": "backpack",
  "name": "Backpack",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/backpack.jpg`,
  "category": "souvenir"
},
{
  "code": "techno_camon_20",
  "name": "Techno Camon",
  "imageUrl": `${SERVER_URL}/assets/images/techno_camon_20.jpg`,
  "category": "phone"
},
{
  "code": "bluetooth_speaker",
  "name": "Bluetooth Speaker",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/bluetooth-speaker.jpg`,
  "category": "souvenir"
},
{
  "code": "powerbank",
  "name": "Powerbank",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/powerbank.jpg`,
  "category": "souvenir"
},
{
  "code": "tank-top",
  "name": "Tank Tops",
  "imageUrl": `${SERVER_URL}/assets/images/tanktop.jpg`,
  "category": "souvenir"
},
{
  "code": "shoprite",
  "name": "Shoprite Vouchers",
  "imageUrl": `${SERVER_URL}/assets/images/shopritemw.jpg`,
  "category": "voucher"
},
{
  "code": "t_shirt",
  "name": "T-Shirt",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/t-shirt.jpg`,
  "category": "souvenir"
},
{
  "code": "bucket_hat",
  "name": "Bucket Hat",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/bucket-hat.jpg`,
  "category": "souvenir"
},
{
  "code": "water_bottle",
  "name": "Water Bottle",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/waterbottle.jpg`,
  "category": "souvenir"
},
{
  "code": "phone",
  "name": "Phone",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/phone.jpg`,
  "category": "voucher"
},
{
  "code": "potbelly",
  "name": "Potbelly Vouchers",
  "imageUrl": `${SERVER_URL}/assets/images/potbellymw.jpg`,
  "category": "voucher"
},
{
  "code": "slingbag",
  "name": "Sling bag",
  "imageUrl": `${SERVER_URL}/assets/images/souvenirs/slingbag.jpg`,
  "category": "souvenir"
},
{
  "code": "melcom",
  "name": "Melcom Vouchers",
  "imageUrl": `${SERVER_URL}/assets/images/melcomemw.jpg`,
  "category": "voucher"
},
{
  "code": "samsung_a24",
  "name": "Samsung A24",
  "imageUrl": `${SERVER_URL}/assets/images/samsung_a24.jpg`,
  "category": "phone"
}];

const greyBgColor = "#C8CBCB";

const useSpinTheWheelHome = () => {
  const { themeContext, theme } = useTheme();
  const {
    itemWon,
    setItemWon,
    spinTheWheelData,
    submitReward,
    isSubmitting,
    submissionResponseData,
    submissionError,
    getSpinTheWheel,
    redeemOrder,
  } = useSpinTheWheel();
  const { state } = useLocation();
  const { rank } = state || {};

  const {
    stock,
    history: userHistory,
    hasPlayed,
    details,
  } = spinTheWheelData || {};
  const {
    whiteListedLocations = [],
    isOnGround,
    requirePointsBuilding,
  } = details || {};

  const getItemFromStock = (itemCode) => {
    const stockArr = stock?.length ? stock : stockData;
    const item = stockArr?.find((item) => item.code === itemCode);
    return item;
  };

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  let history = useHistory();

  const [mustSpin, setMustSpin] = useState(false);
  const [canPlay, setCanPlay] = useState(true);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [data, setData] = useState();
  const [liveStock, setLiveStock] = useState();
  const [color, setColor] = useState();
  const [showModal, setShowModal] = useState(false);
  const [socketConnection, setSocketConnection] = useState();
  const [outOfStockCodes, setOutStockCodes] = useState([]);
  const [isTime9amOrLater, setIsTime9amOrLater] = useState(false);
  const [totalItemsRemaining, setTotalItemsRemaining] = useState();
  const [outOfStockIndexArr, setOutStockIndexArr] = useState([]);

  const lostChance = !itemWon?.won || itemWon?.played;

  const handleSpinClick = () => {
    if (mustSpin) return
    // High reward
    // const phoneIndex = data.findIndex(item => item.code === "phone");

    const itemIndices = [...Array(data.length - 1).keys()];
    const inStockIndices = itemIndices.filter(ind => !outOfStockIndexArr.includes(ind));
    let newPrizeNumber

    // const isTopRanked = rank <= 10;
    // newPrizeNumber = isTopRanked
    //   ? phoneIndex
    //   : inStockIndices[Math.floor(Math.random() * inStockIndices.length)];
    newPrizeNumber = inStockIndices[Math.floor(Math.random() * inStockIndices.length)];
    setPrizeNumber(totalItemsRemaining < 1 ? data.length - 1 : newPrizeNumber);
    setMustSpin(true);
  };

  const onStopSpinning = () => {
    setMustSpin(false);
    const updatedData = data.map((item, index) => {
      if (index === prizeNumber) {
        return {
          ...item,
          hasWon: true,
        };
      } else {
        return item;
      }
    });
    const updatedColor = color.map((item, index) => {
      if (index === prizeNumber && !item.includes(".")) {
        return greyBgColor;
      } else {
        return item;
      }
    });

    setData(updatedData);

    setItemWon(updatedData[prizeNumber]);
    setColor(updatedColor);

    const itemCode = updatedData[prizeNumber].code;
    submitReward(itemCode);
  };

  useEffect(() => {
    if (submissionResponseData) {
      const { won, itemCode } = submissionResponseData?.data || {};
      setItemWon({ ...itemWon, code: itemCode, won });
      setShowModal(true);
      setCanPlay(false);
    }
  }, [submissionResponseData]);

  useEffect(() => {
    if (submissionError) {
      console.log(submissionError);
    }
  }, [submissionError]);

  useEffect(() => {
    if (stock) {
      // Map stock to data
      const outOfStockIndexes = [];
      const outOfStockItemCodes = [];
      const totalItemsRemaining = stock?.reduce((prev, cur) => {
        return prev + (cur?.quantity - cur?.used);
      }, 0);
      const newData = stock.map((item, index) => {
        //  Out stock greying out
        if (item.used >= item.quantity) { outOfStockIndexes.push(index); outOfStockItemCodes.push(item.code) }
        return {
          option: item.name,
          code: item.code,
          style: { textColor: initialColor[index]?.textColor, fontSize: 14 },
          hasWon: false,
          played: false,
        };
      });
      newData.push({
        option: "Better luck next time",
        style: {
          textColor: initialColor[newData.length]?.textColor,
          fontSize: 14,
        },
        hasWon: false,
        played: false,
      });
      setTotalItemsRemaining(totalItemsRemaining);
      setOutStockCodes(outOfStockItemCodes);
      setOutStockIndexArr(outOfStockIndexes);
      setData(newData);
      setColor(
        initialColor.map((item, index) =>
          outOfStockIndexes.includes(index) ? greyBgColor : item.bgColor
        )
      );
    }
  }, [stock]);

  useEffect(() => {
    // Connect to socket
    const socket = io(process.env.REACT_APP_WEBSOCKET_URL, {
      transports: ["polling"],
    });
    socket.on("connect", () => {
      console.log("Connected");
    });

    socket.on("connect_error", (msg) => {
      console.log("Could not connect to socket");
      setTimeout(() => {
        socket.connect();
      }, 1000);
    });
    setSocketConnection(socket);

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (Array.isArray(liveStock)) {
      const totalItemsRemaining = liveStock?.reduce((prev, cur) => {
        return prev + (cur?.quantity - cur?.used);
      }, 0);
      setTotalItemsRemaining(totalItemsRemaining);
      const outOfStockItemCodes = liveStock.filter((item) => item.used >= item.quantity)
        .map(item => item.code);
      setOutStockCodes(outOfStockItemCodes);
      const outOfStockIndexes = data
        .map(((item, index) => outOfStockItemCodes.includes(item.code) ? index : null))
        .filter(item => item !== null);
      setOutStockIndexArr(outOfStockIndexes);
      const updatedColors = color.map(
        (bg, index) => outOfStockIndexes.includes(index) ? greyBgColor : bg
      )
      setColor(updatedColors);
    }
  }, [liveStock]);

  useEffect(() => {
    socketConnection?.on("spinTheWheel", (msg) => {
      setLiveStock(msg);
    });
  }, [socketConnection]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = new Date();
      const currentHour = currentTime.getHours();
      setIsTime9amOrLater(currentHour >= 9);
    }, 1000); // Update every second

    return () => clearInterval(intervalId);
  }, []);

  return {
    handleSpinClick,
    history,
    itemWon,
    setItemWon,
    mustSpin,
    setMustSpin,
    prizeNumber,
    setPrizeNumber,
    data,
    setData,
    showModal,
    setShowModal,
    color,
    setColor,
    lostChance,
    themeColor,
    background,
    isSubmitting,
    onStopSpinning,
    canPlay,
    userHistory,
    stock,
    getItemFromStock,
    hasPlayed,
    outOfStockCodes,
    isTime9amOrLater,
    whiteListedLocations,
    isOnGround,
    redeemOrder,
    getSpinTheWheel,
    requirePointsBuilding,
    spinTheWheelData,
  }
}

export default useSpinTheWheelHome;
